var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btnBody"},[(_vm.prizeDate.id)?_c('dy-button',{attrs:{"type":"blueText"},on:{"click":_vm.setShowType}},[_vm._v(_vm._s(_vm.prizeDate.isShow ? "前台隐藏" : "前台显示"))]):_vm._e(),(_vm.showdel && !_vm.prizeDate.id)?_c('dy-button',{attrs:{"type":"blueText"},on:{"click":_vm.delPrize}},[_vm._v("删除")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }